"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["className", "name", "document", "options"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputRadioGroup/index.js";
function InputRadioGroup(_ref) {
  var className = _ref.className,
    name = _ref.name,
    document = _ref.document,
    options = _ref.options,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classNames["default"])('form-select fs-sm', className);
  function onChangeMale(e) {
    var value = e.target.checked;
    if (value) {
      document[name] = 'Male';
    }
  }
  function onChangeFemale(e) {
    var value = e.target.checked;
    if (value) {
      document[name] = 'Female';
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex flex-column text-wrap lh-1 w-100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "gender",
    Gender: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("small", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 21
    }
  }, "Gender", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-danger",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 25
    }
  }, "*")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check form-check-inline d-flex align-items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("input", {
    onChange: onChangeMale,
    className: "form-check-input me-1",
    type: "radio",
    name: "inlineRadioOptions",
    id: "inlineRadio1",
    value: "option1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 21
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label pt-1",
    htmlFor: "inlineRadio1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("small", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 25
    }
  }, "Male"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check form-check-inline d-flex align-items-center pe-lg-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("input", {
    onChange: onChangeFemale,
    className: "form-check-input me-1",
    type: "radio",
    name: "inlineRadioOptions",
    id: "inlineRadio2",
    value: "option2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 21
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label pt-1",
    htmlFor: "inlineRadio2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("small", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 25
    }
  }, "Female")))));
}
var _default = InputRadioGroup;
exports["default"] = _default;